<canvas baseChart [data]="lineChartData()" [options]="lineChartOptions()" type="line"> </canvas>
